module.exports = __webpack_public_path__ + "img/commitSix.6493ca22.png";